import localStoreMap from "../../store-mapping.json";

// eslint-disable-next-line @typescript-eslint/no-use-before-define
const stores: StoreContent = localStoreMap;

export interface StoreHours {
  sundayHours: string;
  mondayHours: string;
  tuesdayHours: string;
  wednesdayHours: string;
  thursdayHours: string;
  fridayHours: string;
  saturdayHours: string;
}

export interface StoreHoursContent {
  fields: StoreHours;
}

export interface StoreContent {
  [id: string]: {
    payors: string[];
    hours: StoreHours;
  };
}

export interface StoreMapContent {
  name: string;
  stores: StoreContent[];
}

export function fetchPayorsForStore(storeId: string): string[] {
  const store = stores[storeId];
  if (store === undefined) {
    return [];
  }
  const { payors } = store;

  return payors;
}

export function fetchStoreHours(storeId: string): StoreHours | undefined {
  const store = stores[storeId];
  if (store === undefined) {
    return undefined;
  }
  const { hours } = store;

  return hours;
}
